import React from 'react';
import './calculator.css';
import iconHelpCircleBlue from '../../img/baseline-help-24px-blue.svg'
import iconHelpCirclePurple from '../../img/baseline-help-24px-purple.svg'
import iconHelpCircleWhite from '../../img/baseline-help-24px-white.svg'
import iconCheck from '../../img/check_circle_outline-purple-18dp.svg'
import iconCalendar from '../../img/baseline-calc-24px-purple.svg'


function Calculator(props){
	return(
		<div className="calculator-card">
			<div className="main-section-cc bg-blue-50 color-white ">
				<h3 className="title-cc bold text-center">Calcula tu factura</h3>
				<div className="main-sub-section-cc column align-center">
					<div className="row-position color-purple-50 mg-small-cc icon-tooltip">
						<img src={iconHelpCirclePurple} alt="icono ayuda" className="icon-help-circle cursor" />
						<div className="tooltip tooltip-location-one">Ingreso esperado descontado los costos asociados</div>
						<h4 className="text-h4-cc normal">Obtienes por tu factura</h4>
					</div>
					<h1 className="text-h1-cc color-purple-50 mg-small-cc">$ {props.items.totalOperation} COP</h1>
					<div className="row-main-sub-section-cc color-blue-50 row-position justify-between mg-small-cc">
						<div className="row-position align-center icon-tooltip">
							<img src={iconHelpCircleBlue} alt="icono ayuda" className="icon-help-circle cursor" />
							<div className="tooltip tooltip-location-two">El monto que recibirías en tu cuenta bancaria hoy</div>
							<p className="text-h5-cc">Hoy recibirías:</p>
						</div>
						<div>
							<p className="text-h4-cc bold">$ {props.items.netAdvance} COP</p>
						</div>
					</div>
					<div className="row-main-sub-section-cc color-blue-50 row-position justify-between">
						<div className="row-position align-center icon-tooltip">
							<img src={iconHelpCircleBlue} alt="icono ayuda" className="icon-help-circle cursor" />
							<div className="tooltip tooltip-location-two">El monto que recibirías en tu cuenta bancaria el día del pago de tu factura</div>
							<p className="text-h5-cc">El {props.items.dateShort} recibirías:</p>
						</div>
						<div>
							<p className="text-h4-cc bold">$ {props.items.customerPay} COP</p>
						</div>
					</div>
				</div>

				<div className="rectangle-view">
					<div className="row-position justify-between align-center mg-small-cc">
						<div className="row-position align-center icon-tooltip">
							<img src={iconHelpCircleWhite} alt="icono ayuda" className="icon-help-circle cursor" />
							<div className="tooltip tooltip-location-two">Porcentaje que se te girará anticipado sobre el valor neto de las facturas. Este valor puede variar según cada caso</div>
							<p className="text-h5-cc">Porcentaje de anticipo:</p>
						</div>
						<div className="text-h5-cc bold">{ props.items.advancePercentage }%</div>
					</div>
					{props.detailsCostVisible && 
						<div className="row-position justify-between align-center mg-small-cc">
							<div className="row-position align-center icon-tooltip">
								<img src={iconHelpCircleWhite} alt="icono ayuda" className="icon-help-circle cursor" />
								<div className="tooltip tooltip-location-two">Se componen de los ítems inferiores</div>
								<p className="text-h5-cc">Descuentos y costos:</p>
							</div>
							<div className="text-h5-cc bold">$ {props.items.totalCosts} COP</div>
						</div>
					}
				</div>
				
				<div className={props.moreDetailsVisible ? "more-details-cc animation-cc-section" : "more-details-cc"} id="moreDetailsCC">
					<div className={props.moreDetailsVisible ? "fade-in-more-details-cc" : "fade-out-more-details-cc"}>
						<div className="row-position justify-between align-center mg-small-cc">
							<div className="row-position align-start icon-tooltip">
								<img src={iconHelpCircleWhite} alt="icono ayuda" className="icon-help-circle cursor" />
								<div className="tooltip tooltip-location-two">Fee de Mesfix por la operación entre las partes</div>
								<div className="column">
									<p className="text-h5-cc">Comisión de corretaje</p>
									<p className="text-h5-cc">(IVA incluído)</p>
								</div>
							</div>
							<div className="text-h5-cc bold">$ {props.items.comissionMsfxIva} COP</div>
						</div>
						<div className="row-position justify-between align-center mg-small-cc">
							<div className="row-position align-start icon-tooltip">
								<img src={iconHelpCircleWhite} alt="icono ayuda" className="icon-help-circle cursor" />
								<div className="tooltip tooltip-location-two">Costo de la pasarela de pagos y la tenencia física de las facturas</div>
								<div className="column">
									<p className="text-h5-cc">Costo transaccional</p>
									<p className="text-h5-cc">y custodia (IVA incluído)</p>
								</div>
							</div>
							<div className="text-h5-cc bold">$ {props.items.transactionalCost} COP</div>
						</div>
						<div className="row-position justify-between align-center mg-small-cc">
							<div className="row-position align-center icon-tooltip">
								<img src={iconHelpCircleWhite} alt="icono ayuda" className="icon-help-circle cursor" />
								<div className="tooltip tooltip-location-two">Gravamen del recaudado</div>
								<p className="text-h5-cc">4X1000 Anticipo y pago</p>
							</div>
							<div className="text-h5-cc bold">$ {props.items.totalCX1000} COP</div>
						</div>
						<div className="row-position justify-between align-center">
							<div className="row-position align-center icon-tooltip">
								<img src={iconHelpCircleWhite} alt="icono ayuda" className="icon-help-circle cursor" />
								<div className="tooltip tooltip-location-two">Gasto por garantía para respaldar la operación. No aplica en todos los casos</div>
								<p className="text-h5-cc">Costos FNG (IVA incluído)</p>
							</div>
							<div className="text-h5-cc bold">$ {props.items.costFNGIVA} COP</div>
						</div>
					</div>
				</div>
				
				{props.btnMoreDetailsVisible &&
					<div className="justify-center"><button className="btn-msfx-no-bg color-white bold btn-no-change" id="btnMoreDetailsCC" onClick={props.moreDetails}>{props.moreDetailsVisible ? 'Cerrar detalles' : 'Ver detalles'}</button></div>
				}
			</div>
			<div className="second-section-cc column align-center">
				<h3 className="title-second-section-cc color-gray-50">¿Cuál es el valor de tu factura?</h3>
				<div className="section-input-bid mg-items-small">
					<label className="dollar-symbol color-purple-50 bold">$</label>
					<input type="text" name="value" ref={props.refValue} className="input-bid-value color-purple-15 bold" id="offer" placeholder="0" maxLength="13" onChange={props.handleChange}/>
					<label className="cop-symbol color-purple-50 bold">COP</label>
				</div>
			</div>
			<div className="section-cc-changing">
				<div className="second-section-cc-changing column align-center">
					<h3 className="subtitle-second-section-cc text-center color-gray-50">¿Cuál es la fecha de pago de tu factura?</h3>
					<div className="section-input-bid mg-items-small">
						<input type="text" name="paymentDate" className="input-bid-value input-date input-icon color-blue-15 bold" id="paymentDate" placeholder="00/00/0000" maxLength="10" autoComplete="off" onChange={props.handleChange}/>
						<label className="cop-symbol icon-calendar color-blue-50 bold">
							<img src={iconCalendar} alt="icono calendario" />
						</label>
					</div>
					<h3 className="title-second-section-cc color-gray-50 text-center">¿Qué tasa de interés (M.V) quieres proponer en el mercado?</h3>
					<div className="progress-bar-section column">
						<input type="range" name="rate" step="0.1" min="0.6" max="2.0" value={props.items.rate} onChange={props.handleChange} className="range-edit" />
						<div className="values-range justify-between color-gray-50">
							<div className="range-label column align-center">
								<span className="text-h5-cc">0.6%</span>
								
							</div>
							<div className="range-label column align-center">
								<span className="text-h5-cc">0.8%</span>
								
							</div>
							<div className="range-label column align-center">
								<span className="text-h5-cc">1.0%</span>
								
							</div>
							<div className="range-label column align-center">
								<span className="text-h5-cc">1.2%</span>
								
							</div>
							<div className="range-label column align-center">
								<span className="text-h5-cc">1.4%</span>
								
							</div>
							<div className="range-label column align-center">
								<span className="text-h5-cc">1.6%</span>
								
							</div>
							<div className="range-label column align-center">
								<span className="text-h5-cc">1.8%</span>
								
							</div>
							<div className="range-label column align-center">
								<span className="text-h5-cc">2.0%</span>
								
							</div>
						</div>
					</div>
					<p className="text-h6-cc link-market color-gray-50">Entre mayor sea la tasa, más rápido se financiará tu factura.</p>
				</div>
				<div className="section-btn-cc justify-between">
					{props.saveSimulationBtn() ?
						<React.Fragment>
							<button className="btn-msfx-no-bg bold color-purple-50 text-h5-cc btn-no-change" onClick={props.saveSimulation}>Guardar simulación</button>
							<a href="/users/signup" id="empezarcalc_inv"><button className="btn-msfx-rounded bg-purple-50 bold text-h5-cc btn-no-change">Vender mi factura</button></a>
						</React.Fragment>
					:
						<React.Fragment>
							<button className="btn-msfx-no-bg bold color-gray-50 text-h5-cc">Guardar simulación</button>
							<button className="btn-msfx-rounded bg-gray-50 bold text-h5-cc">Vender mi factura</button>
						</React.Fragment>
					}
				</div>
			</div>
			{props.completeData && 
				<div className="complete-data column align-center color-gray-50">
					<h3 className="title-complete-data">Completa tus datos</h3>
					<p className="text-h5-cc description-complete-data">Te enviarémos a tu correo la simulación de tu financiación en Mesfix</p>
					<div className="inputs-complete-data">
						<div className="group mg-inputs-cc">
							<input type="text" className="msfx input-icon" name="documentNumber" onChange={props.handleChange} minLength="8" maxLength="9" autoComplete="off" required />
							<span className="highlight"></span>
							<span className="bar"></span>
							<label className={props.inputValid ? "msfx-purple input-invalid" : "msfx-purple label-error"}>NIT de tu empresa (sin DV)*</label>
							{!props.inputValid && 
								<div className="error-message">No se ha alcanzado el número mínimo de digítos.</div>
							}
							<div className="div-guide">{props.placeholderNit}</div>
						</div>
						<div className="group mg-inputs-cc">
							<input type="text" className="msfx" name="name" onChange={props.handleChange} autoComplete="off" required />
							<span className="highlight"></span>
							<span className="bar"></span>
							<label className="msfx-purple">Nombre y apellido*</label>
						</div>
						<div className="group mg-inputs-cc">
							<input type="text" className="msfx" name="email" onChange={props.handleChange} autoComplete="off" required />
							<span className="highlight"></span>
							<span className="bar"></span>
							<label className="msfx-purple">Correo electrónico*</label>
						</div>
						<div className="group">
							<input type="text" className="msfx" name="phone" onChange={props.handleChange} autoComplete="off" required />
							<span className="highlight"></span>
							<span className="bar"></span>
							<label className="msfx-purple">Celular</label>
						</div>
					</div>
					<div className="column align-center data-policy">
						<p className="text-h6-cc">Al hacer click en ‘Enviar a mi correo’ reconozco que acepto las</p>
						<a href="https://drive.google.com/file/d/0B3DQfy7PdZHiV1JXV3hxNTZ6YWc/view" target="_blank" rel="noopener noreferrer" className="cursor"><p className="text-h6-cc color-purple-50">Políticas de Tratamiento de Datos</p></a>
					</div>
					<div className="section-btn-complete-data justify-between">
						<button className="btn-msfx-no-bg bold color-purple-50 text-h5-cc btn-no-change" onClick={props.editSimulation}>Editar simulación</button>
						{props.validateForm() ?
							<button className="btn-msfx-rounded bg-purple-50 bold text-h5-cc btn-no-change" onClick={props.sendSimulation}>
								Enviar a mi correo
								{props.spinnerVisible && 
									<div className="section-spinner justify-center align-center">
										<svg className="circular">
											<circle className="path" cx="10" cy="10" r="8" fill="none" strokeWidth="2" strokeMiterlimit="10" />
										</svg>
									</div>
								}
							</button>
						:
							<button className="btn-msfx-rounded bg-gray-50 bold text-h5-cc">Enviar a mi correo</button>
						}
					</div>
				</div>
			}
			{props.messageEmailSended &&
				<div className="message-email-sended-section">
					<div className="message-email-sended column align-center justify-end">
						<img src={iconCheck} alt="icono correo enviado" className="icon-check" />
						<h1 className="title-message-email color-gray-50">¡Estás un paso más cerca!</h1>
						<p className="description-message-email color-gray-50 text-center">Revisa tu correo para ver
							la simulación de tu venta de 
							facturas a través de Mesfix.
						</p>
						<div className="section-btn-message-email justify-between">
							<button className="btn-msfx-no-bg bold color-purple-50 text-h5-cc btn-no-change" onClick={props.resetCalculator}>Hacer otra simulación</button>
							<a href="/users/signup"><button className="btn-msfx-rounded bg-purple-50 bold text-h5-cc btn-no-change">Vender mi factura</button></a>
						</div>
					</div>
				</div>
			}
		</div>

	)
}


export default Calculator